<template>
  <div class="safety">
    <div class="title-default">
      安全设置 /
      <span>修改手机号</span>
    </div>
    <div class="safety_password">
      <div class="safety-steps">
        <img src="../../assets/img/pic_jindutiao_1.png" v-if="steps==1" alt />
        <img src="../../assets/img/pic_jindutiao_2.png" v-if="steps==2" alt />
        <div class="safety-steps-text">
          <div :class="{selected:steps>=1}">身份验证</div>
          <div :class="{selected:steps==2}">修改手机号</div>
          <div>修改成功</div>
        </div>
      </div>
      <div class="step-one" v-if="steps==1">
        <div class="phone-number">手机号：{{phoneNum}}</div>
        <div class="phone-tips">若该手机号已无法使用请联系客服</div>
        <div class="verification">
          验证码：
          <el-input class="default-input" v-model="code" placeholder="请输入"></el-input>
          <el-button class="yanzhengma" v-if="getYzm" @click="yzmTimeMinuse()">{{yzmTtext}}</el-button>
          <el-button class="yanzhengma" v-else>{{yzmTime}}S后重发</el-button>
        </div>
        <div>
          <el-button class="xiayibu" :disabled="code.length==0||!yzmImg" @click="modifyPass()">下一步</el-button>
        </div>
        <div class="phone-tishi">
          <div class="tips-title">温馨提醒</div>
          <div>1、为保障您的帐号安全，变更重要信息需要身份验证</div>
          <div>2、更换手机号后，需使用新号码进行登录</div>
          <div>3、若有疑问请联系在线客服</div>
        </div>
      </div>

      <div class="step-two" v-if="steps==2">
        <div>
          <span>手机号码：</span>
          <el-input class="default-input" v-model="phoneValue" maxlength="11" placeholder="输入新的手机号码"></el-input>
        </div>
        <div>
          <span>验证码：</span>
          <el-input class="default-input yanzhengma-input" v-model="vcode" placeholder="请输入"></el-input>
          <el-button class="yanzhengma" v-if="getYzm2" @click="yzmTimePhone()">{{yzmTtext2}}</el-button>
          <el-button class="yanzhengma" v-else>{{yzmTime2}}S后重发</el-button>
        </div>
        <el-button class="xiayibu" @click="success()">下一步</el-button>
      </div>
    </div>
    <Geet :isGeet="isgt" @geetPath="onGeetestValCodePath" @clickChange="onGeetChange"></Geet>
  </div>
</template>

<script>
import Geet from "./Geet.vue";
import { geetestValCodeMixin } from "../../mixins/geetestValCodeMixin";
export default {
  mixins: [geetestValCodeMixin],
  data() {
    return {
      steps: 1,
      code: "",
      vcode: "",
      phoneValue: "",
      input: "",
      getYzm: true,
      yzmImg: false,
      yzmTime: 60,
      getYzm2: true,
      yzmImg2: false,
      yzmTime2: 60,
      yzmTtext2: "发送验证码",
      yzmTtext: "发送验证码"
    };
  },
  components: {
    Geet
  },
  mounted() {
    this.steps = 1;
    this.code = "";
  },
  computed: {
    phoneNum() {
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      return this.$store.state.userPhone.replace(reg, "$1 **** $2");
    }
  },
  methods: {
    onValCodeSent(sceneKey) {
      if (sceneKey === "oldPhone") {
        this.getYzm = false;
        this.yzmTime = 60;
        var auth_timetimer = setInterval(() => {
          this.yzmTime--;
          if (this.yzmTime <= 0) {
            this.getYzm = true;
            clearInterval(auth_timetimer);
            this.yzmTtext = "重新发送";
          }
        }, 1000);
        this.yzmImg = true;
        return;
      }

      if (sceneKey === "newPhone") {
        this.getYzm2 = false;
        this.yzmTime2 = 60;
        var auth_timetimer2 = setInterval(() => {
          this.yzmTime2--;
          if (this.yzmTime2 <= 0) {
            this.getYzm2 = true;
            clearInterval(auth_timetimer2);
            this.yzmTtext2 = "重新发送";
          }
        }, 1000);
        this.yzmImg2 = true;
      }
    },
    //验证码倒计时
    yzmTimeMinuse() {
      this.requestValCodeV2(this.$store.state.userPhone, "oldPhone");
    },
    //验证码倒计时
    yzmTimePhone() {
      var myreg = /^1[123456789]\d{9}$/;

      if (myreg.test(this.phoneValue)) {
        this.requestValCodeV2(this.phoneValue, "newPhone");
      } else {
        this.$message("请输入合法手机号");
      }
    },
    modifyPass() {
      this.$message.closeAll()
      this.$post(
        `/common/platform/verif_sms_code?mobile=${this.$store.state.userPhone}&code=${this.code}`
      ).then(res => {
        if (res.data) {
          this.steps = 2;
        } else {
          this.$message("验证码错误！");
        }
      });
    },
    // 修改成功
    success() {
      this.$message.closeAll()
      // var myreg = /^1[123456789]\d{9}$/;
      // if (myreg.test(this.phoneValue)) {
        this.$post(
          `/user/api/worker/rebind?phone=${this.phoneValue}&code=${this.vcode}`
        ).then(res => {
          if (res.code == 0) {
            this.$message({
              message: "修改手机号成功",
              type: "success"
            });
            setTimeout(() => {
              this.$router.go(-1);
            }, 500);
          } else {
            this.$message(res.message);
          }
        });
      // } else {
      //   this.$message("请输入合法手机号");
      // }
    }
  }
};
</script>

<style lang='scss' scoped>
.safety {
  .step-two {
    & > div {
      span {
        display: inline-block;
        width: 70px;
      }
      .yanzhengma-input {
        width: 122px;
      }
    }
  }
}
</style>
